import { type ReactElement } from 'react'
import { Box, Typography, Link as MuiLink, Grid, Tooltip } from '@mui/material'
import ModalButton from '@/components/common/ModalButton'
import CardContainer from '@/components/dashboard/CardContainer'
import ClaimableAssets from '@/components/dashboard/Assets/ClaimableAssets'
import SendProcessing from '@/components/inheritors/SendProcessing'
import { Body2White } from '@/components/typography'
import { formatCurrency } from '@/utils/formatNumber'

import useDesktop from '@/hooks/useDesktop'
import { type InheritanceOfInheritor } from '@/utils/api'

const InheritanceOfInheritor = ({ inheritances }: { inheritances: InheritanceOfInheritor[] }): ReactElement => {
  const isDesktop = useDesktop()

  // You have a claimable crypto inheritance of 3 tokens, worth $1,000 USD. Inherit it now!
  return (
    <CardContainer title={'Notice of Inheritance'} isHighlighted={true}>
      <Box px={'16px'} flex={1} sx={{ width: '100%' }}>
        <Typography
          display="inline"
          sx={{
            color: 'var(--Ebony-Clay-400)',
            fontSize: '14px',
            fontWeight: '400',
            fontStyle: 'normal',
            lineHeight: '160%',
          }}
          variant="body1"
          component="h2"
        >
          You received a claimable crypto inheritance as below. Claim it now!
        </Typography>

        {inheritances.map((inheritance, index) => {
          const {
            balances: { fiatTotal, items },
            percent,
          } = inheritance
          const value = formatCurrency((parseFloat(fiatTotal) * percent) / 10_000, 'USD')
          return (
            <Grid
              key={`inheritance-${index}`}
              container
              sx={{
                marginTop: '8px',
                borderRadius: '4px',
                border: '1px solid var(--Ebony-Clay-950, #2F354B)',
                background: 'var(--Supporting-Dark-BG-700, #272A3E)',
              }}
            >
              <Grid item container xs={12} sx={{ paddingX: '16px', paddingY: '8px' }}>
                <Grid item container xs={12} sm={5}>
                  <Grid item container xs="auto" justifyContent="center" alignContent="center">
                    <Tooltip title="Who left you this crypto legacy" placement="bottom">
                      <Body2White sx={{ color: 'var(--Ebony-Clay-500)', width: '90px' }}>Inheritance:</Body2White>
                    </Tooltip>
                  </Grid>
                  <Grid item container xs alignContent="center">
                    <Body2White
                      sx={{ color: 'var(--Ebony-Clay-300, #D2D7E5)', fontWeight: 'bold', lineHeight: '160%' }}
                    >
                      {items.length}{' '}
                      <span style={{ fontWeight: '400', lineHeight: '120%', color: 'var(--Ebony-Clay-400)' }}>
                        token {items.length > 1 ? 'types' : 'type'}
                      </span>
                    </Body2White>
                  </Grid>
                </Grid>

                <Grid item container xs={12} sm={4} mt={isDesktop ? '0px' : '4px'}>
                  <Grid item container xs="auto" justifyContent="center" alignContent="center">
                    <Tooltip title="Who left you this crypto legacy" placement="bottom">
                      <Body2White sx={{ color: 'var(--Ebony-Clay-500)', width: isDesktop ? '50px' : '85px' }}>
                        Value:
                      </Body2White>
                    </Tooltip>
                  </Grid>
                  <Grid item container xs alignContent="center">
                    <Body2White
                      sx={{ color: 'var(--Ebony-Clay-300, #D2D7E5)', fontWeight: 'bold', lineHeight: '140%' }}
                    >
                      ~${value.replace('USD', '')}{' '}
                      <span style={{ fontWeight: '400', lineHeight: '120%', color: 'var(--Ebony-Clay-400)' }}>USD</span>
                    </Body2White>
                  </Grid>
                </Grid>

                <Grid item container xs={12} sm alignContent="center" justifyContent="flex-end">
                  <ModalButton
                    titleModal={'Claim inheritance'}
                    contentModal={
                      <SendProcessing>
                        <ClaimableAssets isModal={true} inheritance={inheritance} />
                      </SendProcessing>
                    }
                  >
                    <MuiLink
                      component="button"
                      sx={{
                        fontSize: '14px',
                        color: 'var(--Emerald-600)',
                        textDecorationColor: 'var(--Emerald-600)',
                        '&:hover': {
                          color: 'var(--Emerald-500)',
                        },
                      }}
                      underline="always"
                    >
                      Claim now!
                    </MuiLink>
                  </ModalButton>
                </Grid>
              </Grid>
            </Grid>
          )
        })}

        {/* <Grid
          container
          sx={{
            marginTop: '8px',
            borderRadius: '4px',
            border: '1px solid var(--Ebony-Clay-950, #2F354B)',
            background: 'var(--Supporting-Dark-BG-700, #272A3E)',
          }}
        >
          <Grid item container xs={12} sx={{ paddingX: '16px', paddingY: '8px' }}>
            <Grid item container xs={12} sm={5}>
              <Grid item container xs="auto" justifyContent="center" alignContent="center">
                <Tooltip title="Who left you this crypto legacy" placement="bottom">
                  <Body2White sx={{ color: 'var(--Ebony-Clay-500)', width: '90px' }}>Inheritance:</Body2White>
                </Tooltip>
              </Grid>
              <Grid item container xs alignContent="center">
                <Body2White sx={{ color: 'var(--Ebony-Clay-300, #D2D7E5)', fontWeight: 'bold', lineHeight: '160%' }}>
                  4 <span style={{ fontWeight: '400', lineHeight: '120%', color: 'var(--Ebony-Clay-400)' }}>NFTs</span>
                </Body2White>
              </Grid>
            </Grid>

            <Grid item container xs={12} sm={4} mt={isDesktop ? '0px' : '4px'}>
              <Grid item container xs="auto" justifyContent="center" alignContent="center">
                <Tooltip title="Who left you this crypto legacy" placement="bottom">
                  <Body2White sx={{ color: 'var(--Ebony-Clay-500)', width: isDesktop ? '50px' : '85px' }}>
                    Value:
                  </Body2White>
                </Tooltip>
              </Grid>
              <Grid item container xs alignContent="center">
                <Body2White sx={{ color: 'var(--Ebony-Clay-300, #D2D7E5)', fontWeight: 'bold', lineHeight: '140%' }}>
                  ~$10,000{' '}
                  <span style={{ fontWeight: '400', lineHeight: '120%', color: 'var(--Ebony-Clay-400)' }}>USD</span>
                </Body2White>
              </Grid>
            </Grid>

            <Grid item container xs={12} sm alignContent="center" justifyContent="flex-end">
              <ModalButton
                titleModal={'Claim inheritance'}
                contentModal={
                  <SendProcessing>
                    <ClaimableAssets showTitle={false} isModal={true} />
                  </SendProcessing>
                }
              >
                <MuiLink
                  component="button"
                  sx={{
                    fontSize: '14px',
                    color: 'var(--Emerald-600)',
                    textDecorationColor: 'var(--Emerald-600)',
                    '&:hover': {
                      color: 'var(--Emerald-500)',
                    },
                  }}
                  underline="always"
                >
                  Claim now!
                </MuiLink>
              </ModalButton>
            </Grid>
          </Grid>
        </Grid> */}
      </Box>
    </CardContainer>
  )
}

export default InheritanceOfInheritor
